<template>
  <div id="app">
    <the-header></the-header>
    <the-navigation/>
    <div>
      <router-view/>
    </div>
    <the-footer></the-footer>
  </div>
</template>

<script>
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import VueLocalStorage from 'vue-localstorage'
import Router from 'vue-router'
import routes from './router/routes'
import EventBus from '@/components/event-bus'
import TheNavigation from '@/components/TheNavigation'
import TheHeader from '@/components/Header'
import TheFooter from '@/components/Footer'

import './assets/sass/style.sass'

Vue.use(VueLocalStorage)

export default {
  name: 'app',
  components: {
    TheNavigation,
    TheHeader,
    TheFooter
  },
  data () {
    return {
      savedUserScore: 0,
      saveChaptersDetails: [],
      saveUserChapter: this.$cookie.get('_localuserstatechapter'),
      saveUserQuestion: this.$cookie.get('_localuserstatequestion'),
      saveUserChapterResult: this.$cookie.get('_localuserstatechapterresult'),
    }
  },
  methods: {
    localSaveScore: function (score) {
      // We increment user score and put this variable to cookies.
      this.savedUserScore++
      this.$cookie.set('_localuserscore', this.savedUserScore, 1)
    },
    setPreviousScreen: function (chapter, question, chapterresult) {
      this.$cookie.set('_localuserstatechapter', chapter , 1)
      this.$cookie.set('_localuserstatequestion', question , 1)
      this.$cookie.set('_localuserstatechapterresult', chapterresult , 1)
    },
    localSaveResumeScore: function (chapter, param) {
      Vue.localStorage.set(chapter, param)
    },
    reachScorePanel: function () {
      // We reset all datas
      this.saveChapterDetails = []
      this.saveUserChapter = null
      this.saveUserQuestion = null
      this.saveUserChapterResult = null
      this.savedUserScore = 0
    },
    changeLangPathURL: function (lang) {

    }
  },
  watch: {
    $route(to, from) {
      let lang = this.$i18n.locale
      if ( lang == 'en' ) {
        this.$router.replace(to.meta.en.path)
        document.title = to.meta.en.title
      } else {
        this.$router.replace(to.meta.fr.path)
        document.title = to.meta.fr.title
      }
    }
  },
  mounted: function(){

    //  Watch about correct answer to append global user score.
    EventBus.$on('saveScoreToLocal', this.localSaveScore)

    EventBus.$on('saveTotalChapterScore', this.localSaveResumeScore)

    // We save user state in cookie
    EventBus.$on('saveUserState', this.setPreviousScreen)

    // If user go to score panel
    EventBus.$on('reachScore', this.reachScorePanel)

    EventBus.$on('changeLangPath', this.changeLangPathURL)

    // Comment this to debug
    if ( this.saveUserChapter && this.saveUserQuestion ) {
      this.$router.push({name:'Chapter0'+ this.saveUserChapter + '', params:{lang: this.$i18n.locale}});
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue